export const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export const MathSymbols = {
    numbers: {
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
    },
    letters_lower: {
        a: 'a',
        b: 'b',
        c: 'c',
        d: 'd',
        e: 'e',
        f: 'f',
        g: 'g',
        h: 'h',
        i: 'i',
        j: 'j',
        k: 'k',
        l: 'l',
        m: 'm',
        n: 'n',
        o: 'o',
        p: 'p',
        q: 'q',
        r: 'r',
        s: 's',
        t: 't',
        u: 'u',
        v: 'v',
        w: 'w',
        x: 'x',
        y: 'y',
        z: 'z',
    },
    letters_upper: {
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
        H: 'H',
        I: 'I',
        J: 'J',
        K: 'K',
        L: 'L',
        M: 'M',
        N: 'N',
        O: 'O',
        P: 'P',
        Q: 'Q',
        R: 'R',
        S: 'S',
        T: 'T',
        U: 'U',
        V: 'V',
        W: 'W',
        X: 'X',
        Y: 'Y',
        Z: 'Z',
    },
    symbols: {
        spc: 'Space',
        dec: '.',
        com: ',',
        add: '+',
        sub: '–',
        mul: '×',
        div: '÷',
        eq: '=',
        neq: '≠',
        gt: '>',
        gte: '≥',
        lt: '<',
        lte: '≤',
        lp: '(',
        rp: ')',
        lbr: '[',
        rbr: ']',
        lcb: '{',
        rcb: '}',
        dol: '$',
        cen: '¢',
        per: '%',
        pi: 'π',
        pm: '±',
        col: ':',
        ang: '∠',
        deg: '°',
    },
    expressions: {
        frac: 'Fraction',
        sqrt: 'Square Root',
        nrt: 'Nth Root',
        exp: 'Exponent',
        seg: 'Segment',
        line: 'Line',
        ray: 'Ray',
    },
};

export interface ChoiceDTO {
    id: number;
    text: string;
    text_es: string;
}

export type SerializedHighlight = {
    id: string;
    start: number;
    end: number;
    text: string;
};

export interface UserInteractionMetaDTO {
    strikedQuestionIds: number[] | null;
    highlights: {
        en: SerializedHighlight[];
        es: SerializedHighlight[];
    } | null;
}

// META fields //
export interface QuestionMetaDTO {
    questionTypeMasterId: number;
    keypadSetting: string[];
    gradeLevelMasterIds: number[];
    standards: number[];
    difficultyLevelMasterId: number;
    primaryClaimMasterId: number;
    primaryTargetMasterId: number;
    depthOfKnowledgeMasterId: number;
    isPracticeQuestion: boolean;
    isHandScored: boolean;
    shouldShuffleOptions: boolean;
    shouldShowKeypad: boolean;
    isSpanishAllowed: boolean;
    isDynamicQuestion: boolean;
    score: number;
}

// BASE TYPES //
export interface BaseQtiQuestionDTO {
    id?: number;
    uuid?: string; // Should only be populated when question is loaded (not on create)
    title: string;
    displayValue?: string;
    prompt: string;
    prompt_es: string;
    meta: QuestionMetaDTO;
    correctAnswer?: string;
}
